import { HttpHeaders, HttpClient, HttpHandler, HttpResponse, HttpParams } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Config } from './config';
import { AlertService } from '../admin/component/notification/alert/alert.service';

const httpHeaders = new HttpHeaders({
    /* 'content-type': 'application/x-www-form-urlencoded' */
    'Content-Type': 'application/json',
    /*
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true'
    */
})
const httpOptions = {
    headers: httpHeaders,
    /*  */
};

export class Service {
    private config: Config = new Config();
    //protected _client: HttpClient = new HttpClient(HttpHandler);
    //protected _alertservice: AlertService;
    protected _deleteObjList = [/* 'CreatedDate', 'UpdatedDate', 'Status' */];

    private __url: string = "";
    private __parentUrl: string = "";
    private __baseUrl: string = "";
    /* */
    constructor(private _name: string, private _parentName: string = "", protected _client: HttpClient, protected _alertservice: AlertService) {
        this.__baseUrl = this.config.BaseURL;
        this.__url = this.__baseUrl + this._name.toLowerCase();
        this.__parentUrl = this.config.BaseURL + (this._parentName ? this._parentName.toLowerCase() + "/" : null) + this._name.toLowerCase();
    }

    setRoute(name: string) {
        this.__url = this.config.BaseURL + name.toLowerCase();
    }

    getAll() {
        return this._client.get<any[]>(this.__url, httpOptions)
            .pipe(
                tap(
                    data => {/* this.sucess(data, "got") */ },// this.sucess(data, "get All") ,
                    error => {//this.failure(error);
                        console.error(error);
                    }
                )
            );
    }

    getByID(id: string) {
        return this._client.get<any>(this.__url + "/" + id, httpOptions);
    }

    getByParentID(id: string) {
        return this._client.get<any>(this.__parentUrl + "/" + id, httpOptions)
        /*       .pipe(
                  tap(
                      data => {
                          this.sucess(data, "added");
                          return data;
                      },
                      error => {
                          this.failure(error);
                          return error;
                      }
                  )
              ) */
    }

    getByCompanyID(id: string) {
        let cmpnyUrl = this.config.BaseURL + "company/" + id + "/" + this._name.toLowerCase();
        //console.log(cmpnyUrl);
        return this._client.get<any>(cmpnyUrl, httpOptions);
    }

    getByColumn(id: string, clmn: string) {
        return this._client.post<any>(this.__url + "/" + id + "/" + clmn, httpOptions);
    }

    getByParentName(_name: string) {
        return this._client.get<any>(this.__url + "/" + _name, httpOptions);
    }

    getViewByID(id: string) {
        return this._client.get<any>(this.__url + "/view/" + id, httpOptions);
    }

    save(url: any, _obj: any) {
        return new Promise((resolve, reject) => {
            this.mypost(url.toLowerCase(), _obj).then(
                (data: any) => {
                    resolve(data);
                },
                (error) => {
                    console.error(error);
                    reject(error);
                })
        });
    }

    mypost(path: string, bodyData: any) {
        return new Promise((resolve, reject) => {
            let url = this.config.BaseURL + path.toLowerCase()
            this._client.post(url, bodyData, httpOptions).subscribe(
                (res) => {
                    // this.onSuccess(res);
                    resolve(res);
                },
                (error) => {
                    console.error(error);
                    reject(error);
                }
            );
        })
    }

    post(path: string, data: any) {
        let url = this.config.BaseURL + path.toLowerCase()
        return this._client.post<any[]>(url, data, httpOptions).pipe(
            tap(
                data => {
                    data = data;
                    // console.log("Added", path) 
                },
                error => this.failure(error)
            )

        )
    }


    getByUrl(url: string) {
        // console.log('<----- getByUrl ----->', url);

        const params = new HttpParams()
            .set('page', "PageNo")
            .set('sort', "SortOn")
        // return this._client.get<any>(this.__baseUrl + url, { params })
        return this._client.get<any>(this.__baseUrl + url, httpOptions);
    }

    getEditByID(id: string) {
        return this._client.get<any>(this.__url + "/edit/" + id, httpOptions);
    }

    getInvoiceByID(id: string) {
        return this._client.get<any>(this.__parentUrl + "/" + id, httpOptions);
    }
    getListByID(id: string) {
        return this._client.get<any>(this.__parentUrl + "/list/" + id, httpOptions);
    }

    getDListByID(url: string) {
        return this._client.get<any>(this.__baseUrl + url, httpOptions);
    }


    get(path: string, data: any) {
        let url = this.config.BaseURL + path.toLowerCase()
        /*  console.log(url);
         console.log(path); */
        //return this._client.get<any[]>(url, data);
        return this._client.get<any[]>(url);
    }
    importData(obj: any) {
        return this._client.post<any[]>(this.__url + "/import", obj, httpOptions)
            .pipe(
                tap(
                    data => {
                        obj = data;
                        // console.log("Added")
                    },
                    error => this.failure(error)
                )
            )
    }

    importSData(nm: any, obj: any) {
        return this._client.post<any[]>(this.config.BaseURL + nm + "/import/s", obj, httpOptions).pipe(
            tap(
                data => {
                    obj = data;
                    // console.log("Added") 
                },
                error => this.failure(error)
            ))
    }
    /*     importSData(obj: any) {
            return this._client.post<any[]>(this.__url + "/import/s", obj, httpOptions).pipe(
                tap(
                    data => { obj = data; console.log("Added") },
                    error => this.failure(error)
                ))
        } */

    create(data: any) {
        for (var i = 0; i < this._deleteObjList.length; i++) {
            delete data[this._deleteObjList[i]];
        }
        return this._client.post<any[]>(this.__url, data, httpOptions).pipe(
            tap(
                data => {
                    this.sucess(data, "added");
                    return data;
                },
                error => {
                    this.failure(error);
                    return error;
                }
            )
        )
    }

    ncreate(data: any) {
        for (var i = 0; i < this._deleteObjList.length; i++) {
            delete data[this._deleteObjList[i]];
        }
        return this._client.post<any[]>(this.__url + "/new", data, httpOptions).pipe(
            tap(
                data => {
                    this.sucess(data, "added")
                    //_success(data);
                    //return data;
                },
                error => {
                    this.failure(error);
                    //_error(error);
                }
            )
        )
    }
    npost(id: string, data: any) {
        // console.log(this.__parentUrl + "/" + id);
        return this._client.post<any[]>(this.__parentUrl + "/" + id, data, httpOptions).pipe(
            tap(
                data => {
                    this.sucess(data, "added")
                    //_success(data);
                    //return data;
                },
                error => {
                    this.failure(error);
                    //_error(error);
                }
            )
        )
    }
    update(data: any) {
        for (var i = 0; i < this._deleteObjList.length; i++) {
            delete data[this._deleteObjList[i]];
        }
        return this._client.put<any[]>(this.__url + "/" + data.ID, data, httpOptions).pipe(
            tap(
                data => this.sucess(data, "updated"),
                error => this.failure(error)
            )
        )
    }
    delete(_id: string) {
        return this._client.delete<any[]>(this.__url + "/" + _id, httpOptions).pipe(
            tap(
                data => this.sucess(data, "deleted"),
                error => this.failure(error)
            ))
    }

    sucess(msg: any, msgType: any) {
        //console.log("Fired");
        this._alertservice.add(this._name.toUpperCase(), "Has been " + msgType + " Sucessfully ", "Success");
    }
    failure(err: any) {
        // console.log("Fired");
        return err;
        //let msg = err.error;
        this._alertservice.add("Error", err.error.error, "Error");
    }
}